import { 
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit, inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { finalize } from 'rxjs';
import Currencies from 'src/assets/data/currencies.json';
import { MomentService } from 'src/app/shared/services/moment.service';
@Component({
  selector: 'app-local-uob',
  templateUrl: './local-uob.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LocalUobComponent implements OnInit {
  private momentService = inject(MomentService);
  bankAccs: any[] = [];
  private _data: any = {};
  currencyOptions: any[] = [];
  get data(): any {
    return this._data;
  }
  @Input() set data(val: any) {
    this._data = val;

    this.form.patchValue({
      payeeName: val.payeeName?.slice(0, 35),
      currency: val.foreign.currency,
      payeeCurrency: val.foreign.currency,
      amount: val.foreign.amount
    });
  }

  form = this.fb.group({
    account: ['', [Validators.required, Validators.maxLength(30)]],
    accountCurrency: ['', []],
    payeeCurrency: [{ value: '', disabled: false }, [Validators.required]],
    payeeName: ['', [Validators.required, Validators.maxLength(35)]],
    payeeAccount: ['', [Validators.required, Validators.maxLength(19)]],
    isResident: [true, [Validators.required]],
    transferDate: [new Date(), [Validators.required]],
    amount: [
      0,
      [
        Validators.required,
        Validators.min(0.01),
        Validators.max(9999999999999.99)
      ]
    ],
    currency: ['', [Validators.required]],
    payeeRef: ['', [Validators.required, Validators.maxLength(35)]]
  });

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    this.momentService.moment().diff(current, 'days') > 0;

  constructor(
    private fb: FormBuilder,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef
  ) {
    this.form.controls.account.valueChanges.subscribe(val => {
      if (val) {
        const bank = this.bankAccs.find(x => x.bankAccountNo === val);
        if (bank) {
          this.form.controls.accountCurrency.setValue(bank.currencyCode);
        }
      }
    });

    this.form.controls.currency.valueChanges.subscribe(val => {
      if (val === this.data.foreign.currency)
        this.form.controls.amount.setValue(this.data.foreign.amount);
      else this.form.controls.amount.setValue(this.data.local.amount);

      this.form.controls.payeeCurrency.setValue(val);

      // if (val === 'MYR') this.form.controls.payeeCurrency.disable();
      // else this.form.controls.payeeCurrency.enable();
    });
  }

  ngOnInit(): void {
    this.currencyOptions = Currencies.filter(x => x.code).map(x => {
      return { label: x.code, value: x.code };
    });
    this.loadBankAccounts();
  }

  private loadBankAccounts() {
    let url = `api/accountcodes/search?$top=10&$skip=0&$orderby=code asc`;
    var filter = `IsActive eq true and BankTypeCode eq 'UOB' and BankAccountNo ne null and BankAccountNo ne ''`;
    url = `${url}&$filter=${filter}`;
    this.http
      .get(url)
      .pipe(
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        if (res.value) {
          res.value.forEach((item: any) => {
            item.label = `${item.bankAccountNo} (${item.currencyCode})`;
          });

          this.bankAccs = [...res.value];
        }
      });
  }
}
